import { type FormEvent, useState } from 'react';
import { ChessBut } from '../components/Brand.tsx';
import { api } from '../lib/api.ts';
import { Link } from '../lib/router.tsx';

export function IdeasPage() {
  const [text, setText] = useState('');
  const [sent, setSent] = useState(0);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api('/api/ideas', { body: { text } });
      setSent((n) => n + 1);
      setText('');
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <h1 className="page-title">Suggest a variant</h1>
      <p className="muted">
        Every day is a new “chess, but…”. Got a twist you want to see? If it makes the cut, you get credited on screen in the reel.
      </p>
      <form className="card idea-form" onSubmit={submit}>
        <label htmlFor="idea">Your twist</label>
        <div className="idea-input">
          <span className="idea-prefix">chess, but</span>
          <input id="idea" value={text} maxLength={140} placeholder="the knights are on fire" onChange={(e) => setText(e.target.value)} required />
        </div>
        {error && <p className="form-error">{error}</p>}
        <button className="btn primary big block" disabled={busy || text.trim().length < 3}>
          {busy ? 'Sending…' : 'Send it'}
        </button>
        {sent > 0 && <p className="good center">Got it! Thanks. {sent > 1 ? `(${sent} ideas today)` : ''}</p>}
      </form>
      {text.trim().length >= 3 && <ChessBut as="h2" twist={text.trim().replace(/^chess,?\s*but\s*/i, '')} />}
      <p className="muted small center">
        Ideas are read by a human, not published. <Link to="/days">See what’s already out →</Link>
      </p>
    </div>
  );
}
